import React, { useState } from 'react';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import { usePhrase } from '@/hooks';
import { CircularProgress, Paper } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Phrases } from '@/consts/phrases';

interface FileDropZoneProps {
    upload: (files: File[]) => Promise<void>;
    isDisabled: boolean;
}

export const FileDropZone = (props: FileDropZoneProps) => {
    const { upload } = props;
    const [isUploading, setIsUploading] = useState<boolean>(false);
    const { t } = usePhrase();

    const onDrop: DropzoneOptions['onDrop'] = (acceptedFiles) => {
        setIsUploading(true);
        void upload(acceptedFiles).then(() => setIsUploading(false));
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        disabled: isUploading || props.isDisabled,
        onDrop,
    });

    return (
        <Paper
            {...getRootProps()}
            sx={{
                mt: 2,
                p: 2,
                cursor: props.isDisabled ? 'not-allowed' : 'pointer',
                height: '5rem',
                textAlign: 'center',
                bgcolor: isDragActive ? 'grey.400' : 'grey.100',
            }}
            data-testid="drop-zone-root"
        >
            <input {...getInputProps()} />
            {!isUploading && (
                <>
                    {t(Phrases.DRAG_AND_DROP)}
                    <br />
                    <CloudUploadIcon />
                </>
            )}
            {isUploading && <CircularProgress data-testid="progress" />}
        </Paper>
    );
};
